<template>
  <v-container fluid class="feature-page">
    <div class="float-to-center m__b--80">
      <h2>
        Send to other e-Wallet
      </h2>
    </div>

    <v-row class="feature-content">
      <v-col cols="12" md="4" sm="6" v-for="(data, index) in feature_list" :key="index">
        <v-row>
          <v-col cols="3">
            <div class="wrapping" :class="data.logo">
              <v-img
              :src="require(`@/assets/${data.logo}.svg`)"
              :lazy-src="require(`@/assets/${data.logo}.svg`)"
              width= "25px" />
            </div>
            
          </v-col>
          <v-col>
            <h3 class="m__b--16">{{data.title}}</h3>
            <p>
              {{data.description}}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
  
  
</template>

<script>
export default {
  data() {
    return {
      feature_list: [
        {
          title: 'Aman dan terpercaya',
          description: 'Bebaskan diri Anda dari: resiko mengirim uang e-Wallet yang tidak aman',
          logo: 'shield',
        },
        {
          title: 'Potongan Murah',
          description: 'Tranfer antar e-Wallet hanya mendapat potongan yang murah.',
          logo: 'discount',
        },
        {
          title: 'Kirim kemana saja',
          description: 'Sekarang anda bisa kirim e-Wallet anda kemana saja',
          logo: 'money',
        },
        {
          title: 'Atur keuangan dengan tepat',
          description: 'Kelola dan Monitor pengeluaran Anda menggunakan Transfr',
          logo: 'cost',
        },
        {
          title: '1 Transaksi Rp 500',
          description: 'Hanya dengan Rp 500 anda bisa kirim e-Wallet anda ke semua',
          logo: 'wallet',
        },
        {
          title: 'Nikmati layanan lainnya',
          description: 'Dapatkan kepuasan lainnya hanya bergabung bersama kami',
          logo: 'information',
        },
      ]
    }
  }
}
</script>

<style lang="scss">

  .feature-page {
    h2 {
      max-width: 600px;
      text-align: center;
    }
    .feature-content {
      p {
        color: #9A9EA6;
      }
      .shield, .wrapping {
        background: #FEF9F6;
        padding: 10px;
        border-radius: 100px;
        width: 45px;
      }
      .discount {
        background: #EEF4FF;
      }
      .money {
        background: #FFF2F9;;
      }
      .cost {
        background: #EFFFF6;
      }
      .wallet {
        background: #FFF2F2;
      }
      .information {
        background: #F9F2FF;
      }
    }
     @media screen and (max-width: 500px) {
      .m__b--80 {
        margin-bottom: 30px !important;
      }
    }
  }
</style>
